import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import { getStoreResource } from '@/utils/store';
import React from 'react';
import { Schedule } from '../Schedule';
import { Properties } from './Content/Properties';
import { SelectIndicators } from './Content/SelectIndicators';

export default function BulkCreateAlarms () {
    const initialData = {
        indicatorIds: [],
        indicatorKind: '',
        maxValue: 0,
        minValue: 0,
        name: '',
        schedule: {},
        type: 'instantaneous',
        userIds: []
    };

    const steps = [
        { Component: Properties, title: i18next.t('alarms.bulk_create'), description: i18next.t('alarms.bulk_create_description') },
        { Component: SelectIndicators, title: i18next.t('alarms.bulk_indicators'), description: i18next.t('alarms.bulk_indicators_description') },
        { Component: Schedule, title: i18next.t('modal.title.alarm_schedules.new') }
    ];

    const handleSubmit = async data => {
        const indicatorKind = getStoreResource('indicatorKinds', data.indicatorKind);
        const unit = getStoreResource('units', indicatorKind.unit_id)?.symbol;

        if (unit === 'Wh')        {
            data.minValue = data.minValue * 1000;
            data.maxValue = data.maxValue * 1000;
        }

        let finalData = {
            indicator_ids: data.indicatorIds,
            type: data.type,
            user_ids: data.userIds
        };

        if (data.type !== 'baseline') {
            finalData.name = data.name;
            finalData.max_value = data.maxValue;
            finalData.min_value = data.minValue;
            finalData.schedule = data.schedule;
        }

        try {
            const response = await apiRequest('/alarms/bulk_create', 'POST', finalData);

            WiseMetering.alarms.fetch();

            return response;
        } catch (err) {
            throw new Error(err); // Throwing it so Wizard can catch
        }
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
